module.exports = __webpack_public_path__ + "img/types_of_ownership_min.7566b21e.jpg";